/* @jsx h */
// import { useRef, useEffect, useState } from 'preact/hooks';
import { useRef, useState, useEffect } from 'preact/hooks';
import { Fragment } from 'preact';
import { labels } from '../../config';

const MapZipSearchInput = ({
  query,
  label,
  numericRangeFilterObj,
  triggerAjaxSubmit,
  pluginNamespace,
  isReset,
  toggleLoadingAnimation,
  updateUserCoordinates,
  placeholder,
  coordinatesApi,
  range,
  noCoordinatesFound,
  invalidZipCode,
  handleZipInput,
  resetFilters,
}) => {
  const addressInputEl = useRef(null);
  const [showClearOption, setShowClearOption] = useState(false);

  useEffect(() => setShowClearOption(!!query), [query]);

  function handleInputChange() {
    if (addressInputEl && addressInputEl.current) {
      const value = addressInputEl.current.value;
      setShowClearOption(!!value);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    const zipRegex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
    const inputValue = addressInputEl.current?.value;
    const isValidPostalCode = zipRegex.test(inputValue);
    inputValue && handleZipInput(isValidPostalCode);
  }

  function clearInput(e) {
    e.preventDefault();
    setShowClearOption(false);
    handleZipInput(true, true);
    addressInputEl.current.focus();
    resetFilters([`${pluginNamespace}[q]`]);
  }

  // use browser geolocation
  // function handleGeoLocationClick() {
  //   if (navigator.geolocation) {
  //     const options = {
  //       enableHighAccuracy: true,
  //     };
  //     toggleLoadingAnimation(true);
  //     navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
  //   } else {
  //     onError();
  //   }
  // }

  // function onSuccess(position) {
  //   const coords = removeWhitespaceAndLinebreaks(`${position.coords.latitude},
  //       ${position.coords.longitude}`);
  //   setCoordinates(coords);
  //   updateUserCoordinates(coords);
  //   setNoCoordinatesFound(false);
  //   handleSubmit();
  // }

  // function onError() {
  //   toggleLoadingAnimation(false);
  //   console.error();
  // }

  // useEffect(() => {
  //   if (isReset) {
  //     hiddenInputEl.current.value = '';
  //     addressInputEl.current.value = '';
  //     setNoCoordinatesFound(false);
  //     setCoordinates('');
  //   }
  // }, [isReset]);

  // useEffect(() => {
  //   if (coordinates) {
  //     // trigger submit
  //     triggerAjaxSubmit();
  //   }
  // }, [coordinates]);

  return (
    <Fragment>
      <div className="search-input">
        <div className="search-input__input">
          <div className="input-text input-text--search-input">
            <label
              className="input-text__label sr-only"
              htmlFor="input-text-search"
            >
              {labels.search.searchField}
            </label>
            <input
              id="input-text-search"
              className="input-text__input"
              data-main-input
              name={`${pluginNamespace}[q]`}
              ref={addressInputEl}
              onChange={handleInputChange}
              // onKeyPress={handleSubmit}
              autoComplete="off"
              placeholder={placeholder || labels.search.placeholder || ''}
              type="text"
              aria-describedby={
                invalidZipCode
                  ? 'desc-invalid-zip-code'
                  : noCoordinatesFound
                  ? 'desc-no-coordinates-found'
                  : null
              }
              aria-invalid={noCoordinatesFound || invalidZipCode ? true : null}
            />
          </div>
          {showClearOption && (
            <button
              className="search-input__clear"
              type="button"
              onClick={clearInput}
              aria-controls="input-text-search"
            >
              <span className="search-input__clear-icon icon icon--cross">
                <svg className="icon__svg" role="img" aria-hidden="true">
                  <use href="#icon-cross" />
                </svg>
                <span className="sr-only">
                  {labels.search.clearSearchField}
                </span>
              </span>
            </button>
          )}
        </div>
        <div className="search-input__button">
          <button
            className="styled-button styled-button--search-input"
            type="submit"
            onClick={handleSubmit}
          >
            <span className="styled-button__text">{labels.search.submit}</span>
            <span className="styled-button__icon icon icon--magnifier">
              <svg className="icon__svg" role="img" aria-hidden="true">
                <use href="#icon-magnifier" />
              </svg>
            </span>
          </button>
        </div>
      </div>
      {noCoordinatesFound && (
        <p className="search-input__message" id="desc-no-coordinates-found">
          <span>{labels.map.noCoordsFound || ''}</span>
        </p>
      )}
      {invalidZipCode && (
        <p className="search-input__message" id="desc-invalid-zip-code">
          <span>{labels.map.invalidZipCode || ''}</span>
        </p>
      )}
    </Fragment>
  );
};

export default MapZipSearchInput;
